import { render, staticRenderFns } from "./ReceivableBalance.vue?vue&type=template&id=27321bb8&scoped=true&"
import script from "./ReceivableBalance.vue?vue&type=script&lang=js&"
export * from "./ReceivableBalance.vue?vue&type=script&lang=js&"
import style0 from "./ReceivableBalance.vue?vue&type=style&index=0&id=27321bb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27321bb8",
  null
  
)

export default component.exports